import angular from 'angular';

module.exports = angular.module('common.models.session', [
  require('angular-resource'),
  require('./human'),
  require('./responser')
])
.factory('Session', function($resource, $http, Human, Responser) {
  var transformer = Responser.appendTransform(function(result) {
    return { logged_in: !!result.id, human: new Human(result) };
  });

  var Session = $resource('/api/v1/me', {}, {
    info: {
      method: 'GET',
      url: '/session/info',
      transformResponse: Responser.appendTransform(function(result) {
        if (result && result.human) result.human = new Human(result.human);
        return result;
      })
    },
    me: {
      method: 'GET',
      url: '/api/v1/me',
      transformResponse: transformer
    },
    login: {
      method: 'POST',
      url: '/login',
      transformResponse: transformer
    },
    logout: {
      method: 'DELETE',
      url: '/logout',
      transformResponse: function() { return {}; } // clear the credential
    }
  });

  return Session;
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/models/session.js
 **/